import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  ActivityIndicator,
} from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';

/**
 * Transaction Processing Content - Shows spinner while payment is being processed
 */
export const TransactionProcessingContent: React.FC = () => {
  return (
    <View style={styles.container}>
      {/* Spinner */}
      <View style={styles.spinnerContainer}>
        <ActivityIndicator
          size="large"
          color={MARKETPLACE_COLORS.accentBlueSolid}
        />
      </View>

      {/* Processing Text */}
      <Text style={styles.processingText}>
        Transaction details are sending. Please wait. This should only take a few moments.
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    paddingHorizontal: 32,
  },
  spinnerContainer: {
    marginBottom: 24,
  },
  processingText: {
    fontSize: 16,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 24,
    textAlign: 'center',
    maxWidth: 280,
  },
});

export default TransactionProcessingContent;

